import { defineStore } from 'pinia';
import ServiceExec, { customToast } from '@/common/utils/ServiceExec';
import { admin } from '@/common/service/api/apiList';
import { SESSION_TIME_OUT } from '@/common/constants/ConstCode';
const { changePassword, login, logout } = admin;

export const useAccountStore = defineStore('account', {
  state: () => ({
    loginData: {
      authNo: '',
      id: '',
      joinType: '',
      role: ''
    },
    role: '',
    accessToken: '',
    sessionTime: null
  }),
  getters: {},
  actions: {
    async login(params) {
      const { status, data, headers } = await ServiceExec.patch(login, params);

      if (await customToast(status, data?.message, '')) {
        const { authorization } = headers;
        this.setLoginData(data);
        this.accessToken = authorization;
        this.setSessionTime(authorization);
        return true;
      } else return false;
    },
    async logout() {
      await ServiceExec.post(logout);
      this.setLoginData();
      this.accessToken = null;
      this.sessionTime = null;
    },
    changePassword: async (form) => {
      const { status, data } = await ServiceExec.patch(changePassword, form);
      return await customToast(status, data.message, '저장되었습니다.');
    },
    setLoginData(
      data = {
        authNo: '',
        id: '',
        joinType: '',
        role: ''
      }
    ) {
      console.log('set login data {}', data);
      this.loginData = data;
    },
    setSessionTime(accessToken) {
      let sessionTime = null;
      if (accessToken) {
        const now = new Date().getTime();
        sessionTime = now + SESSION_TIME_OUT.nHour(1);
      }
      this.sessionTime = sessionTime;
    }
  },
  persist: true
});